import { Controller } from "@hotwired/stimulus"

// Recharge une autre Turbo Frame de la page (les « Chiffres clés » après un enregistrement), depuis
// l'URL qu'elle déclare dans data-reload-src.
export default class extends Controller {
  static values = { id: String }

  connect() {
    const frame = document.getElementById(this.idValue)
    if (!frame?.dataset.reloadSrc) return
    frame.src = `${frame.dataset.reloadSrc}?at=${Date.now()}`
  }
}
